import { render } from "./depense.vue?vue&type=template&id=51b888db&scoped=true"
import script from "./depense.vue?vue&type=script&lang=js"
export * from "./depense.vue?vue&type=script&lang=js"

import "./depense.vue?vue&type=style&index=0&id=51b888db&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b888db"]])

export default __exports__